import React, { useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideClick = <T extends HTMLElement>(ref: React.RefObject<T | null>, callback: () => void) => {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && event.target && !ref.current.contains(event.target as Node)) {
                callback();
            }
        };

        const handleTouchOutside = (event: TouchEvent) => {
            if (ref.current && event.target && !ref.current.contains(event.target as Node)) {
                callback();
            }
        };

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleTouchOutside);

        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleTouchOutside);
        };
    }, [ref, callback]);
};
